export enum TreasureFiLinks {
  BankAccountAgreement = 'https://www.treasurefi.com/bank-account-agreement',
  HelpBox = 'https://www.treasurefi.com/#hs-chat-open',
  InvestmentDisclosures = 'https://www.treasurefi.com/investment-disclosures',
  InvestmentManagementAgreement = 'https://www.treasurefi.com/investment-agreement',
  PrivacyPolicy = 'https://www.treasurefi.com/privacy-policy',
  TermsOfUse = 'https://www.treasurefi.com/terms-of-use',
}
